export const RoofTypes = {
    gable:"Gable",
    skillion_right:"Skillion Right",
    skillion_left:"Skillion Left",
    // american_barn:"American Barn",
    // australian_barn:"Australian Barn",
    // skillion_barn:"Skillion Barn",
}